export const emptySetTitle = 'There are no completed files on this service request yet.';
export const emptySetDescription = 'Upload fixed files here.';
